// Firebase Configuration Helper
// Copy this file and update with your actual Firebase project details

export const firebaseConfig = {
  // Replace with your Firebase project configuration
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "your-api-key-here",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "varkwaveprod.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "varkwaveprod",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "varkwaveprod.appspot.com", 
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "your-sender-id",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "your-app-id",
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

export const vapidKey = import.meta.env.VITE_FIREBASE_VAPID_KEY || "your-vapid-key-here";

// Environment variables you need to set:
// VITE_FIREBASE_API_KEY=your-firebase-api-key
// VITE_FIREBASE_AUTH_DOMAIN=varkwaveprod.firebaseapp.com  
// VITE_FIREBASE_PROJECT_ID=varkwaveprod
// VITE_FIREBASE_STORAGE_BUCKET=varkwaveprod.appspot.com
// VITE_FIREBASE_MESSAGING_SENDER_ID=your-sender-id
// VITE_FIREBASE_APP_ID=your-app-id
// VITE_FIREBASE_MEASUREMENT_ID=G-XXXXXXXXXX (optional)
// VITE_FIREBASE_VAPID_KEY=your-vapid-key

export const isFirebaseConfigured = () => {
  return !!(
    firebaseConfig.apiKey &&
    firebaseConfig.projectId &&
    firebaseConfig.messagingSenderId &&
    firebaseConfig.appId &&
    firebaseConfig.apiKey !== "your-api-key-here"
  );
};

